/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CommentAssociatedEntity { 
    entity_id: string;
    entity_title: string;
    entity_type: CommentAssociatedEntity.EntityTypeEnum;
}
export namespace CommentAssociatedEntity {
    export type EntityTypeEnum = 'Post';
    export const EntityTypeEnum = {
        Post: 'Post' as EntityTypeEnum
    };
}